export const AUTH_STATE = {
  pending: 'pending',
  authorized: 'authorized',
  notAuthorized: 'notAuthorized'
} as const
